(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){
        $('.product-single__form').on('click', '.qty-plus', function(e) {
            let $input = $(this).prev('input.qty');
            let val = parseInt($input.val());
            $input.val( val+1 ).change();
        });
 
        $('.product-single__form').on('click', '.qty-minus', function(e) {
            let $input = $(this).next('input.qty');
            var val = parseInt($input.val());
            if (val > 1) {
                $input.val( val-1 ).change();
            }
        });

    $('.product-single__form').on('change', '#mobile_qty', 
            function(e) {
            $("#quantity").val($(this).val());
        });
  };
  

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-3.6.0.js', function(){
      jQuery = jQuery.noConflict(true);
    });
  } else {
    myCode(jQuery);
  }

})();

var elem = document.querySelector('.pl-swatches__container');

var flkty = new Flickity( elem, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true,
    groupCells: 1
});

var prevBtn = document.querySelector('.flickity-previous');

flkty.on( 'change', function() {
    prevBtn.style.display = 'block';
});